import type { Id } from '@/infra/id'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooterSection,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
  ModalSheetFooter,
  ModalSheetContentBox,
} from '@/components/ModalSheet'
import styles from './WorkspaceInvitationModal.module.css'
import { Button } from '@/components/Button'
import { Icon } from '@/components/Icon'
import { formattedTimeUntil } from '@/utils/date-util'
import { Congrats } from '@/features/opportunities/components/Congrats'

export interface WorkspaceInvitationModalProps {
  id: Id
  showing: boolean
  software: string
  location: string
  specs: string
  description: string
  timeUntilExpiration: number
  isAcceptPending: boolean
  onAccept: () => unknown
  isRejectPending: boolean
  onReject: () => unknown
}

export function WorkspaceInvitationModal({
  id,
  showing,
  software,
  location,
  specs,
  description,
  timeUntilExpiration,
  isAcceptPending,
  onAccept,
  isRejectPending,
  onReject,
}: WorkspaceInvitationModalProps) {
  return (
    <ModalSheet showing={showing} disableCloseOnEsc disableCloseOnOutsideClick>
      <ModalSheetHeader />
      <ModalSheetContent leftAligned>
        <ModalSheetContentBlock>
          <Congrats />
          <ModalSheetContentTitle>
            You're invited to join a Workspace
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            To claim, review the outsourcing opportunity below.
          </ModalSheetContentDescription>
          <ModalSheetContentBox testId={`invitation-modal-${id}`} color="green">
            <span
              className={styles.software}
              data-test={`invitation-modal-software-${id}`}
            >
              {software}
            </span>
            <div className={styles.location}>
              <p>{location}</p>
            </div>
            <div className={styles.specs}>
              <p>{specs}</p>
            </div>
            <p className={styles.description}>{description}</p>
            <div className={styles.offerAction}>
              <Button
                label="Accept Opportunity"
                onPress={onAccept}
                isPending={isAcceptPending}
                block
                testId={`invitation-modal-accept-button-${id}`}
                variant="success"
                size="cta"
              />
            </div>
          </ModalSheetContentBox>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSection>
          <div className={styles.countdownDisplay}>
            <Icon className={styles.clock} name="clock" auto />
            Auto-rejecting in{' '}
            <span className={styles.countdown}>
              {formattedTimeUntil(timeUntilExpiration)}
            </span>
          </div>
        </ModalSheetFooterSection>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Decline Opportunity"
            onPress={onReject}
            isPending={isRejectPending}
            testId={`reject-modal-reject-button-${id}`}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
